import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ColorPalette } from 'shared/consts/colorPalette';
import { GuideStep } from 'widgets/startRecognition/ui/GuideModal/ui/GuideStep';
import { GuideText } from 'widgets/startRecognition/ui/GuideModal/ui/GuideText';

const GenerativeInstructions: FC = () => {
	const { t } = useTranslation();

	return (
		<Box sx={{ pr: '120px', overflowY: 'auto', maxWidth: '1020px', overflowX: 'hidden' }}>
			<Typography variant={'subtitle1'} color={ColorPalette.astronaut}>
				{t('generative_model.description')}
			</Typography>

			<GuideStep>{t('custom_model.step_1.title')}</GuideStep>
			<GuideText>{t('generative_model.step_1.description')}</GuideText>

			<GuideStep>{t('custom_model.step_2.title')}</GuideStep>
			<GuideText>{t('generative_model.step_2.description')}</GuideText>

			<GuideStep>{t('custom_model.step_3.title')}</GuideStep>
			<GuideText>{t('generative_model.step_3.description')}</GuideText>

			<GuideStep>{t('custom_model.step_4.title')}</GuideStep>
			<GuideText>{t('generative_model.step_4.description')}</GuideText>

			<GuideStep>{t('custom_model.step_5.title')}</GuideStep>
			<GuideText>{t('generative_model.step_5.description')}</GuideText>
		</Box>
	);
};

export default GenerativeInstructions;
